// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.formulate-input[data-v-76a0a707] input {
    margin: 0;
    height: 1.25rem;
    width: 1.25rem;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
    background-position: center;
    background-repeat: no-repeat;
    padding: 0;
}
.formulate-input[data-v-76a0a707] input:checked {
    --tw-border-opacity: 1;
    border-color: rgb(31 47 75 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(31 47 75 / var(--tw-bg-opacity));
}
.formulate-input[data-v-76a0a707] input {
    background-image: url(/img/web/checkbox-check.svg);
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/inputs/box/CheckboxInput.vue"],"names":[],"mappings":";AAsBA;IAAA,SAAA;IAAA,eAAA;IAAA,cAAA;IAAA,wBAAA;OAAA,qBAAA;YAAA,gBAAA;IAAA,kBAAA;IAAA,iBAAA;IAAA,mBAAA;IAAA,sBAAA;IAAA,yDAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,UAAA;AAAA;AAAA;IAAA,sBAAA;IAAA,sDAAA;IAAA,kBAAA;IAAA,sDAAA;AAAA;AADA;IAEA,kDAAA;AACA","sourcesContent":["<template>\n  <BoxInput type=\"checkbox\" v-bind=\"$attrs\" :checked=\"checked\" />\n</template>\n\n<script>\nimport BoxInput from '@/lego/components/inputs/box/BoxInput.vue';\n\nexport default {\n  components: {\n    BoxInput,\n  },\n  props: {\n    checked: {\n      type: Boolean,\n    },\n  }\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.formulate-input::v-deep {\n  input {\n    @apply w-[1.25rem] h-[1.25rem] border-solid p-0 rounded-[5px] border-hairline border-neutral-semilight appearance-none bg-no-repeat bg-center checked:bg-brand-secondary-medium checked:border-brand-secondary-medium m-0;\n    background-image: url(/img/web/checkbox-check.svg);\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
